import { Link } from 'react-router-dom';
import { useReveal } from '@/hooks/useReveal';
import { COMPANY_TEASER } from '@/data/mockData';
import s from './CompanyTeaser.module.scss';

// ── 회사소개 짧은 티저 (D안 Phase 2-④) ──────────────────────────────
//   홈 하단(오시는 길 위). 회사소개는 후순위라 "짧게" — 한 줄 소개 + /company 진입.
//   모션: evs.com 리빌 계승.
//   우측 그래픽(2026-09-05, 사용자 "이 방향성 좋아"): evstech 'IoT Gateway' 개념을 재해석 —
//     중앙 게이트웨이(wifi) + 방사형 센서 노드(잎=환경 포함). "사물을 연결" 상징을 시안 라인으로.
//     대안 거부: 하늘 사진(과함)·단색 파랑(밋밋)·요소 나열식 인포그래픽(재해석 아님).
//     톤은 다크 네이비 유지 + 시안 라인($cyan) — evs.com/as 언어.
export default function CompanyTeaser() {
  const reveal = useReveal<HTMLDivElement>();
  return (
    <section className={s.section}>
      <div className={s.inner} ref={reveal}>
        <div className={`${s.box} anim-scroll`}>
          <span className={s.eyebrow}>{COMPANY_TEASER.eyebrow}</span>
          <h2 className={s.headline}>{COMPANY_TEASER.headline}</h2>
          <p className={s.desc}>{COMPANY_TEASER.desc}</p>
          <Link to={COMPANY_TEASER.to} className={s.cta}>
            {COMPANY_TEASER.cta}
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
              <path d="M7 17L17 7M17 7H9M17 7v8" />
            </svg>
          </Link>
        </div>

        {/* IoT 게이트웨이 재해석 그래픽 (2026-09-05 사용자 확정) — FLAT PCB:
            좌 안전 / 우 환경 '두 축'을 중앙 게이트웨이 허브가 연결. 노드 = EVS 실제 장비.
            입체감·그라디언트·라벨 없음(사용자 지시). 안전=시안 #00AEEF / 환경=그린 #35c17e.
            변경 금지 트리거: 반반 원(두 축 상징)·라벨 없음·플랫 유지. */}
        <div className={`${s.gfx} anim-scroll`} aria-hidden="true">
          <svg viewBox="0 0 440 320" fill="none">
            {/* 트레이스: 안전(시안) */}
            <g stroke="#00AEEF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M190 160 L99 160" />
              <path d="M198 144 L168 144 Q158 144 158 134 L158 74 Q158 64 148 64 L99 64" />
              <path d="M198 176 L168 176 Q158 176 158 186 L158 246 Q158 256 148 256 L99 256" />
            </g>
            {/* 트레이스: 환경(그린) */}
            <g stroke="#35c17e" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M250 160 L341 160" />
              <path d="M242 144 L272 144 Q282 144 282 134 L282 74 Q282 64 292 64 L341 64" />
              <path d="M242 176 L272 176 Q282 176 282 186 L282 246 Q282 256 292 256 L341 256" />
            </g>
            {/* 중앙 게이트웨이 = 평면 반반 원(입체감 없음) + 칩 아이콘 */}
            <path d="M220 130 A30 30 0 0 0 220 190 Z" fill="#00AEEF" />
            <path d="M220 130 A30 30 0 0 1 220 190 Z" fill="#35c17e" />
            <circle cx="220" cy="160" r="30" fill="none" stroke="#0b1219" strokeWidth="1.3" opacity="0.3" />
            <g transform="translate(220,160)" stroke="#0b1219" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
              <rect x="-9" y="-9" width="18" height="18" rx="3" />
              <path d="M-4 -13v3M4 -13v3M-4 10v3M4 10v3M-13 -4h3M-13 4h3M10 -4h3M10 4h3" />
            </g>
            {/* 안전 노드(좌): 체감온도계 · 가스검침 · 안전경보 */}
            <g transform="translate(74,64)"><rect x="-25" y="-25" width="50" height="50" rx="13" fill="#141d29" stroke="#00AEEF" strokeWidth="1.3" /><g transform="translate(-13,-13) scale(1.08)" stroke="#00AEEF" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3a2.4 2.4 0 0 1 2.4 2.4v7.6a4 4 0 1 1-4.8 0V5.4A2.4 2.4 0 0 1 12 3z" /><circle cx="12" cy="16.4" r="1.5" fill="#00AEEF" stroke="none" /></g></g>
            <g transform="translate(74,160)"><rect x="-25" y="-25" width="50" height="50" rx="13" fill="#141d29" stroke="#00AEEF" strokeWidth="1.3" /><g transform="translate(-13,-13) scale(1.08)" stroke="#00AEEF" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="8.5" cy="15" r="3" /><circle cx="15.5" cy="15" r="3" /><circle cx="12" cy="8.5" r="3" /><path d="M10.3 10.6 9.7 12.6M13.7 10.6l.6 2M11 15h2" /></g></g>
            <g transform="translate(74,256)"><rect x="-25" y="-25" width="50" height="50" rx="13" fill="#141d29" stroke="#00AEEF" strokeWidth="1.3" /><g transform="translate(-13,-13) scale(1.08)" stroke="#00AEEF" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3.5l8.5 15h-17z" /><line x1="12" y1="10" x2="12" y2="14" /><circle cx="12" cy="16.5" r="0.9" fill="#00AEEF" stroke="none" /></g></g>
            {/* 환경 노드(우): 전류계 · 차압계 · pH계 */}
            <g transform="translate(366,64)"><rect x="-25" y="-25" width="50" height="50" rx="13" fill="#141d29" stroke="#35c17e" strokeWidth="1.3" /><g transform="translate(-13,-13) scale(1.08)" stroke="#35c17e" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M13 2 5 13h5l-1 9 8-12h-5z" /></g></g>
            <g transform="translate(366,160)"><rect x="-25" y="-25" width="50" height="50" rx="13" fill="#141d29" stroke="#35c17e" strokeWidth="1.3" /><g transform="translate(-13,-13) scale(1.08)" stroke="#35c17e" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M4 18a8 8 0 1 1 16 0" /><line x1="12" y1="18" x2="16.5" y2="12.5" /><circle cx="12" cy="18" r="1.5" fill="#35c17e" stroke="none" /></g></g>
            <g transform="translate(366,256)"><rect x="-25" y="-25" width="50" height="50" rx="13" fill="#141d29" stroke="#35c17e" strokeWidth="1.3" /><g transform="translate(-13,-13) scale(1.08)" stroke="#35c17e" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M9 3h6M10 3v5l-4.5 9A2 2 0 0 0 7.3 20h9.4a2 2 0 0 0 1.8-3L14 8V3" /><line x1="8" y1="14" x2="16" y2="14" /></g></g>
          </svg>
        </div>
      </div>
    </section>
  );
}
